import React, { useEffect, useState } from "react";
import "../../questionBank/QBankFilter.css";
import { useBlogFilters } from "../../hooks/useBlogFilters";

const EMPTY_FILTERS = {
  blog_category_id: "",
  tag_id: "",
  read_unread_id: "",
  bookmark_status: "",
};

const BlogFilter = ({ isOpen, onClose, onApply, onReset, params, appliedFilters }) => {
  // The mobile app loads filter metadata alongside the first page of results.
  const { data: groups = [], isLoading, isError, error } = useBlogFilters(params);
  const [draftFilters, setDraftFilters] = useState(appliedFilters);
  const [openGroup, setOpenGroup] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setDraftFilters(appliedFilters);
    }
  }, [appliedFilters, isOpen]);

  return (
    <aside className={`qbf${isOpen ? " is-open" : ""}`} aria-hidden={!isOpen}>
      <div className="qbf__header">
        <div><h2 className="qbf__title">Filters</h2><p className="qbf__subtitle">Refine your articles</p></div>
        <button type="button" className="qbf__close" onClick={onClose} aria-label="Close filters"><i className="bi bi-x-lg" /></button>
      </div>
      <div className="qbf__chipRow">
        <button type="button" className={`qbf__chip${draftFilters.bookmark_status === 1 ? " is-active" : ""}`} onClick={() => setDraftFilters((current) => ({ ...current, bookmark_status: current.bookmark_status === 1 ? "" : 1 }))}><i className="bi bi-bookmark" />Bookmarked</button>
      </div>
      <div className="qbf__groups">
        {isLoading ? <div className="choose-state__status">Loading filters...</div> : null}
        {isError ? <div className="choose-state__status choose-state__status--error">{error?.message || "Unable to load filters."}</div> : null}
        {groups.map((group) => {
          const selected = group.options.find((option) => String(option.value) === String(draftFilters[group.id]));
          const isGroupOpen = openGroup === group.id;
          return <div className={`qbf__groupWrap${isGroupOpen ? " is-open" : ""}`} key={group.id}>
            <button type="button" className="qbf__group" onClick={() => setOpenGroup(isGroupOpen ? null : group.id)}><span className="qbf__groupIcon"><i className={group.icon} /></span><span className="qbf__groupCopy"><strong>{group.title}</strong><span>{selected?.label || "All"}</span></span><i className={`bi ${isGroupOpen ? "bi-chevron-up" : "bi-chevron-down"} qbf__chevron`} /></button>
            {isGroupOpen ? <div className="qbf__dropdown"><button type="button" className={`qbf__option${!draftFilters[group.id] ? " is-active" : ""}`} onClick={() => setDraftFilters((current) => ({ ...current, [group.id]: "" }))}>All</button>{group.options.map((option) => <button type="button" className={`qbf__option${String(draftFilters[group.id]) === String(option.value) ? " is-active" : ""}`} key={option.value} onClick={() => setDraftFilters((current) => ({ ...current, [group.id]: option.value }))}>{option.label}</button>)}</div> : null}
          </div>;
        })}
      </div>
      <div className="qbf__actions"><button type="button" className="qbf__apply" onClick={() => { onApply(draftFilters); onClose(); }}><i className="bi bi-funnel" />Apply Filters</button><button type="button" className="qbf__reset" onClick={() => { setDraftFilters(EMPTY_FILTERS); onReset?.(); onClose(); }}><i className="bi bi-arrow-clockwise" />Reset Filters</button></div>
    </aside>
  );
};

export { EMPTY_FILTERS };
export default BlogFilter;
